module.exports = __webpack_public_path__ + "static/media/tiendas_landing.1e1d3c21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tiendas/tiendas_landing.png
// module id = 2181
// module chunks = 0